import React, { Component, createRef, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import classNames from 'classnames';
import {setNotice} from '../../actions';
import {Api} from '../../util';

import CheckBox from '../checkbox';

const modalRoot = document.getElementById('root');

class UserDetail extends Component {
	constructor(props){
		super(props);
		this.state = {
            defaultImg: "/static/img/close_icon_d.png",
            overImg: "/static/img/close_icon_s.png",
            changeImgFlag: false,
            defaultPwd: "wshopping1!",
            idCheck: false,
            userId: '',
            pwd: '',
            pwdChk: '',
            oldPwd: '',
            userName: '',
            userAuth : 'G',
            memo: '',
            useYN : false
        };
        
        this.userIdRef = createRef();
        this.pwdRef = createRef();
        this.pwdChkRef = createRef();
        this.userNameRef = createRef();
        this.oldPwdRef = createRef();

        this.handleOnMouseOver = this.handleOnMouseOver.bind(this);
        this.handleOnMouseLeave = this.handleOnMouseLeave.bind(this);

        this.handleIdChk = this.handleIdChk.bind(this);
        this.handleUserId = this.handleUserId.bind(this);
        this.handleUserPw = this.handleUserPw.bind(this);
        this.handleUserPwChk = this.handleUserPwChk.bind(this);
        this.handlePwdCk = this.handlePwdCk.bind(this);
        this.handleOldPwd = this.handleOldPwd.bind(this);

        this.handleUserNm = this.handleUserNm.bind(this);
        this.handleUserAuth = this.handleUserAuth.bind(this);
        this.handleMemo = this.handleMemo.bind(this);
        this.handleCheck = this.handleCheck.bind(this);

        this.SearchUser = this.SearchUser.bind(this);

        this.handleUserSave = this.handleUserSave.bind(this);
	}

  componentDidMount(){
    const {userData, userInfoType} = this.props;
    if(userInfoType === "user" ){
      this.SearchUser();
    }else if(userData && Object.keys(userData).length !== 0){
      this.setState({
          userId: userData.ID || '',
          userName: userData.NAME || '',
          userAuth: userData.AUTH || 'G',
          memo: userData.MEMO || '',
          useYN: userData.USEYN === 'Y' || false,
      })
    }
    // const isEmptyObj =  Object.keys(userData).length === 0;
  }

  // 사용자 검색
  async SearchUser(){
    let userData = [];
    try{
        const resUser = await Api.SearchUserEx();
        const userList = resUser.files.user;
        userData = userList.filter(info => {
          return info.ID === sessionStorage.getItem('id');
        });
        if(userData.length > 0){
          await this.setState({
            userId: userData[0].ID,
            userName: userData[0].NAME,
            userAuth: userData[0].AUTH,
            memo: userData[0].MEMO,
            useYN: userData[0].USEYN,
          });
        }
    } catch(e) {
        console.log(e, "SearchUser");
    }
}

  async handleIdChk(){
    const {userId} = this.state;
    try{
      if(userId){
        await Api.isInsertUser({ID: userId});
        await this.setState({idCheck: true});
        this.props.setNotice(true, 'success', "사용 가능한 아이디입니다");
      }
    }catch(e){
      console.log(e);
      this.setState({idCheck: false});
      this.props.setNotice(true, 'fail', e.detail);
    }
  }

    handleOnMouseOver(){
        this.setState({changeImgFlag: true});
    }
    handleOnMouseLeave(){
        this.setState({changeImgFlag: false});
    }

    handleUserId(e){
        this.setState({
          userId: e.target.value,
          idCheck: false
        })
    }

    handleUserPw(e){
      this.setState({
        pwd: e.target.value
      })
    }
    handleUserPwChk(e){
      this.setState({
        pwdChk: e.target.value
      })
    }
    handleUserNm(e){
      this.setState({
        userName: e.target.value
      })
    }
    handleMemo(e){
      this.setState({
        memo: e.target.value
      })
    }
    handleUserAuth(e){
      this.setState({
        userAuth: e.target.value
      })
    }

    handleCheck(e){
      this.setState(prevState => {
        return {
          useYN: !prevState.useYN
        }
      })
    }

    handlePwdCk(){
      const { pwd, pwdChk } = this.state;
      if(pwd.length > 0 || pwdChk.length > 0){ // 비밀번호 수정할 경우
        return true;
      }else{
        return false;
      }
    }

    // ID와 비밀번호 3자리 중복 확인
    handleIdPwdCk(){
      const { userId, pwd } = this.state;
      let chrBool = false;
      for(let i=0; i<userId.length; i++){
        let firstChr = userId.charAt(i);
        let secondChr = userId.charAt(i+1);
        let thirdChr = userId.charAt(i+2);
        
        let chr = firstChr + secondChr + thirdChr;
        let chrCheck = pwd.toLocaleLowerCase().includes(chr.toLocaleLowerCase());
        if(chr.length === 3 && chrCheck ) return chrBool = true;
      }
      return chrBool;
    }

    handleOldPwd(e){
      this.setState({
        oldPwd: e.target.value
      })
    }

    warnInvalidValue(content){
        this.props.setNotice(true, "fail", content);
    }
    checkValdidation() {
      const {userInfoType} = this.props;
      const { userId, idCheck, pwd, pwdChk, oldPwd,
        userName} = this.state;
            
      // 8자리 이상
      const check = /^(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9])(?=.*[0-9]).{8,}$/.test(pwd); // 영문, 숫자, 특수문자

      //   const chkNum = pwd.search(/[0-9]/g);  // 숫자
      //   const chkEngAa = pwd.search(/[A-Za-z]/g);  // 영문 대소문자
      //   const chkSpecial = pwd.search(/[!@#$%^&*()\-_=+\\\/\[\]{};:\`",.<>\/?]/g);  // 특수문자
      //   let chkCnt = 0;

      // if(chkNum >= 0)  chkCnt += 1; 
			// if(chkEngAa >= 0)  chkCnt += 1; 
			// if(chkSpecial >= 0)  chkCnt += 1; 
      

        // 아이디 동일한 비번 확인
        const warringText = userInfoType==="user" ? "기존 비밀번호를 입력해주세요" : `${sessionStorage.getItem('name')}의 비밀번호를 입력해주세요`;

        if(userId === "" && userInfoType==="add"){
          this.warnInvalidValue("ID를 입력해주세요");
          this.userIdRef.focus();
          return false;
        }else if(!idCheck && userInfoType==="add"){
          this.warnInvalidValue("아이디 중복검사를 확인해주세요");
          this.userIdRef.focus();
          return false;
        // }else if(pwd === "" && userInfoType==="add"){
        //   this.warnInvalidValue("비밀번호를 입력해주세요");
        //   this.pwdRef.focus();
        //   return false;
        // }else if(!(check) && userInfoType==="add"){
        //   this.warnInvalidValue("비밀번호는 8자리 이상 영문, 숫자, 특수문자로 조합해주세요");
        //   this.pwdRef.focus();
        //   return false;
        // }else if(/(\w)\1\1\1/.test(pwd) && userInfoType==="add"){
        //   this.warnInvalidValue("비밀번호에 같은 문자를 연속으로 4번이상 사용하실 수 없습니다.");
        //   this.pwdRef.focus();
        //   return false;
        // }else if(this.handleIdPwdCk() && userInfoType==="add") {
        //   this.warnInvalidValue("비밀번호에 아이디를 3자이상 포함하여 사용하실 수 없습니다.");
        //   this.pwdRef.focus();
        //   return false;
        // }else if(pwdChk === "" && userInfoType==="add"){
        //   this.warnInvalidValue("비밀번호 확인을 입력해주세요");
        //   this.pwdChkRef.focus();
        //   return false;
        // }else if(pwdChk !== pwd && userInfoType==="add"){
        //   this.warnInvalidValue("비밀번호 확인을 다시 입력해주세요");
        //   this.pwdChkRef.focus();
        //   return false;
        // 비밀번호 변경시
        }else if(userInfoType!=="add"){
          if(pwd === ""){
            this.warnInvalidValue("비밀번호를 입력해주세요");
            this.pwdRef.focus();
            return false;
          // }else if(!(check)){
          //   this.warnInvalidValue("비밀번호는 8자리 이상 영문, 숫자, 특수문자로 조합해주세요");
          //   this.pwdRef.focus();
          //   return false;
          // }else if(/(\w)\1\1\1/.test(pwd)){
          //   this.warnInvalidValue("비밀번호에 같은 문자를 연속으로 4번이상 사용하실 수 없습니다.");
          //   this.pwdRef.focus();
          //   return false;
          // }else if(this.handleIdPwdCk()) {
          //   this.warnInvalidValue("비밀번호에 아이디를 3자이상 포함하여 사용하실 수 없습니다.");
          //   this.pwdRef.focus();
          //   return false;
          }else if(pwdChk === "" ){
            this.warnInvalidValue("비밀번호 확인을 입력해주세요");
            this.pwdChkRef.focus();
            return false;
          }else if(pwdChk !== pwd){
            this.warnInvalidValue("비밀번호 확인을 다시 입력해주세요");
            this.pwdChkRef.focus();
            return false;
          }else if(oldPwd === ""){
              this.warnInvalidValue(warringText);
              this.oldPwdRef.focus();
              return false;
          }else{
            return true;
          }
        }else if(userName === ""){
          this.warnInvalidValue("사용자 이름을 입력해주세요");
          this.userNameRef.focus();
          return false;
        }else if(oldPwd === ""  && userInfoType==="add" ){
          this.warnInvalidValue(warringText);
          this.oldPwdRef.focus();
          return false;
        }else{
          return true;
        }
      }

    // 사용자 정보 저장
    handleUserSave(){
      const {userInfoType} = this.props;
      const {userId, defaultPwd, pwd, userName, userAuth, memo, useYN, oldPwd } = this.state;
      const cmdData = {
        LOGIN_ID: sessionStorage.getItem("id"),
        LOGIN_PWD: oldPwd,
        ID: userId,
        PWD: userInfoType === "add" ? defaultPwd : pwd,
        NAME: userName,
        AUTH: userAuth,
        MEMO: memo,
        USEYN: useYN ? 'Y' : 'N'
      };
      let checkSave = false;
      switch(sessionStorage.getItem("auth")){
        case "A":
        case "M":
          checkSave=true;
          break;
        case "U":
        case "G":
          sessionStorage.getItem("id") === userId ? checkSave=true : checkSave=false;
          break;
        default:
          checkSave=false;
          break;
      }
      
      if(checkSave){
        if(this.checkValdidation()){
            this.props.handleUserUpdate(cmdData);
            this.props.handleUserHide();
        }
      }else{
        this.warnInvalidValue("잘못된 접근입니다.");
      }
    }

	render() {
        const {
            defaultImg,
            overImg,
            changeImgFlag,

            userId,
            idCheck,
            pwd,
            pwdChk,
            defaultPwd,
            userName,
            userAuth,
            memo,
            oldPwd,
            useYN

        } = this.state;
        const {
            userInfoType,
            handleUserHide
        } = this.props;


        const authName = (auth) => {
          switch(auth){
              case "G":
                  return "게스트";
              case "U":
                  return "사용자";
              case "A":
                  return "관리자";
              default:
                  return "";
          }
      }

		return ReactDOM.createPortal(
			<div id="modal-wrap">
        <div className = "modal user-container">
          <div className="header">
            <div>사용자 {userInfoType === "add" ? "추가" : "편집"}</div>
            <div onClick={handleUserHide} onMouseOver={this.handleOnMouseOver} onMouseLeave={this.handleOnMouseLeave}>
              <span className="icon modal-close"></span>
            </div>
          </div>

          <div className="detail-wrapper">
            <div className="content-item-group">
              <div className="content-item">
                <div className="caption">
                  사용자ID
                </div>
                <div className="value">
                  {userInfoType === "add" ?
                    <Fragment>
                      <input type="text" value={userId} onChange={this.handleUserId} autoFocus ref={i => this.userIdRef = i }  />
                      <button type="button" disabled={idCheck} onClick={this.handleIdChk}>아이디 확인</button>
                    </Fragment>
                  :
                      <span>{userId}</span>
                  }
                </div>
              </div>

                <div className="content-item">
                  <div className="caption">
                    비밀번호
                  </div>
                  <div className="value">
                  {userInfoType === "add" ?
                  <Fragment>
                    <span>{defaultPwd}</span>
                  </Fragment>
                  :
                  <input type="password"  value={pwd} onChange={this.handleUserPw} ref={i => this.pwdRef = i } />
                  }
                    </div>
                </div>

                <div className="content-item">
                  <div className="caption">
                    비밀번호 확인
                  </div>
                  <div className="value">
                  {userInfoType === "add" ?
                  <Fragment>
                    <span>{defaultPwd}</span>
                  </Fragment>
                  :
                    <input type="password" value={pwdChk} onChange={this.handleUserPwChk} ref={i => this.pwdChkRef = i } />
                  }
                </div>
                </div>

                <div className="content-item">
                  <div className="caption">
                    이름
                  </div>
                  <div className="value">
                  {userInfoType === "user" ?
                    <span>{userName}</span>
                    :
                    <input type="text" value={userName} onChange={this.handleUserNm} ref={i => this.oldPwdRef = i } />
                  }
                  </div>
                </div>

                <div className="content-item">
                  <div className="caption">
                    권한
                  </div>
                  <div className="value">
                  {userInfoType === "user" ?
                      <span>{authName(userAuth)}</span>
                    :
                    <select value={userAuth} onChange={this.handleUserAuth}>
                      <option value="G">게스트</option>
                      <option value="U">사용자</option>
                      <option value="A">관리자</option>
                    </select>
                  }
                  </div>
                </div>
                
                <div className="content-item">
                  <div className="caption">
                    메모
                  </div>
                  <div className="value">
                  {userInfoType === "user" ?
                    <span>{memo}</span>
                  :
                    <input type="text" value={memo} onChange={this.handleMemo}/>
                  }
                  </div>
                </div>

                <div className="content-item">
                  <div className="caption">
                    사용여부
                  </div>
                  <div className="value">
                  {userInfoType === "user" ?
                    <span>{useYN ? 'Y' : 'N'}</span>
                    :
                    <CheckBox id={`use_yn`} checked={useYN}
                      handleOnClick={this.handleCheck}
                    />
                  }
                  </div>
                </div>

                
                <div className="content-item">
                  <div className="caption">
                    {userInfoType === "user" ? "기존 비밀번호" : `${sessionStorage.getItem('name')}의 비밀번호`}
                  </div>
                  <div className="value">
                    <input type="password" value={oldPwd} onChange={this.handleOldPwd} ref={i => this.oldPwdRef = i } />
                  </div>
                </div>

              </div>
            </div>
            
            <div className="footer">
              <button type="button" onClick={this.handleUserSave}>저 장</button>
              <button type="button" onClick={handleUserHide}>닫 기</button>
            </div>

        </div>
			</div>
		, modalRoot);
	}
}
const mapStateToProps = state => {
  return {
    userInfoType: state.userInfoType,
  }
}


const mapDispatcherToProps = dispatch => {
  return {
    setNotice: (flag, state, content) => dispatch(setNotice(flag, state, content))
  }
};

UserDetail = connect(mapStateToProps,mapDispatcherToProps)(UserDetail);
export default UserDetail;


// WEBPACK FOOTER //
// ./src/components/modal/UserDetail.js